import React from "react";
import PropTypes from "prop-types";
import { Button } from "@fluentui/react-components";
import { FormattedMessage } from "react-intl";
import { Modal } from "../modal/Modal";

export function MediaAcquisitionErrorModal({ message, onClose }) {
  return (
    <Modal
      title={<FormattedMessage id="media-acquisition-error-modal.title" defaultMessage="Couldn’t add media" />}
      onClose={onClose}
      actions={
        <Button appearance="primary" onClick={onClose}>
          <FormattedMessage id="media-acquisition-error-modal.close-button" defaultMessage="Close" />
        </Button>
      }
    >
      <p>
        {message || (
          <FormattedMessage
            id="media-acquisition-error-modal.message"
            defaultMessage="We couldn’t add that link. Check the URL and try again."
          />
        )}
      </p>
    </Modal>
  );
}

MediaAcquisitionErrorModal.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func
};
